'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n'], ['\n  width: 100%;\n  height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n  margin-bottom: 20px;\n'], ['\n  text-align: center;\n  margin-bottom: 20px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 150px;\n  height: 4px;\n  margin: 0px auto;\n'], ['\n  width: 150px;\n  height: 4px;\n  margin: 0px auto;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSpinners = require('react-spinners');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../libs/colors');

var _Center = require('../Center/Center');

var _Center2 = _interopRequireDefault(_Center);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject);

var Content = _styledComponents2.default.div(_templateObject2);

var BarContent = _styledComponents2.default.div(_templateObject3);

var ScreenLoader = function ScreenLoader(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(Container, null, _react2.default.createElement(_Center2.default, null, _react2.default.createElement('div', null, !!children && _react2.default.createElement(Content, null, children), _react2.default.createElement(BarContent, null, _react2.default.createElement(_reactSpinners.BarLoader, {
    width: 150,
    height: 4,
    color: _colors.red
  })))));
};

ScreenLoader.propTypes = {
  children: _propTypes2.default.node // height: PropTypes.string,

};
ScreenLoader.defaultProps = {// height: null,
};
exports.default = ScreenLoader;